const ItemsModel = function () {
    return {
        all: [], // -
        showed: [], // -
        checkBoxes: [], // -
        chosen: [],
        reset: function () {
            this.checkBoxes.forEach((it_) => {
                it_.checked = false;
            });
            this.checkBoxes = [];
            this.chosen = [];
        }, // -

        addToChosen: function (item) {
            if (!this.chosen.includes(item)) {
                this.chosen.push(item);
                return true;
            } else {
                return false;
            }
        },

        removeFromChosen: function (itemUuid) {
            const initialLength = this.chosen.length;
            this.chosen = this.chosen.filter((item) => item !== itemUuid);
            return this.chosen.length;
        },

        clearChosen: function () {
            this.chosen = [];
        },

        getShowedIds: function () {
            return this.showed.map((item) => item);
        },

        getChosenIds: function () {
            return this.chosen.map((item) => item);
        },

        setShowed: function (showed) {
            this.showed = [...showed];
            this.updatePrev();
        },

        updatePrev: function () {
            const lasts = this.showed.filter((selectedItem) =>
                this.chosen.includes(
                    selectedItem.id || selectedItem.uid || selectedItem.uuid,
                ),
            );
            let last = lasts.at(-1);
            if (last === undefined) {
                this.setItem({ ...this.item });
                this.setShowPrev(false);
            } else {
                this.setItem(last);
                this.setShowPrev(this.chosen.length > 0);
            }

        },

        getChosenUuids: function () {
            return this.chosen.map((item) => item);
        },
    };
};
export default ItemsModel;